import { z } from 'zod';
/**
 * Ambiente de despliegue del middleware: `production`, `staging` o
 * `development`.
 *
 * Existe porque `NODE_ENV` no alcanza para decirlo: el servidor de desarrollo de
 * DigitalOcean corre con `NODE_ENV=production` (`docker-compose.server.yml`) y
 * es, a la vez, donde se prueba el flujo de venta completo con las simulaciones.
 *
 * Falla CERRADO: sin `DEPLOYMENT_TIER`, `NODE_ENV=production` es `production`.
 * La API lo informa al monitor (capacidades de la simulacion) para que la UI
 * tampoco ofrezca una simulacion en produccion, sin depender de como alguien
 * escribio la etiqueta del ambiente al compilarla.
 */
export const DEPLOYMENT_TIERS = ['production', 'staging', 'development'];
export const deploymentTierSchema = z.enum(DEPLOYMENT_TIERS, {
    errorMap: () => ({ message: 'El ambiente es production, staging o development.' }),
});
//# sourceMappingURL=deployment-tier.js.map